import * as React from 'react';
import './PromoText.scss';

export function PromoText() {
  return <>{/* <div className="ePromoText">
                Promo text ...
            </div> */}</>;
}
